import React, { Fragment } from 'react';

import { Icon } from '../Icon';
import { Link } from '../Link';
import { Tooltip } from '../Tooltip';
import * as S from './breadcrumb.styles';
import { BreadcrumbProps } from './breadcrumb.types';

import ChevronRight from '@/icons/chevron_right.icon.svg';

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  history,
  navigateFn,
  tooltipPosition = 'left',
}) => {
  const currentUrl = window.location.pathname;

  const labelsLength = [...history.map(({ label }) => label)].map((str) => str.length);
  const minLength = Math.min(...labelsLength);
  const hasMinLength = labelsLength.map((len) => len === minLength);

  return (
    <S.BreadcrumbWrapper>
      {history.map(({ label, url, isBlocked }, index) => {
        const isCurrent = url === currentUrl;

        return (
          <Fragment key={index}>
            {index > 0 && (
              <S.ChevronContainer>
                <Icon icon={ChevronRight} />
              </S.ChevronContainer>
            )}
            <S.BreadcrumbElement $hasMinLength={hasMinLength[index]}>
              <Tooltip type="text" content={label} position={tooltipPosition} preserveWidth>
                <Link
                  isBlocked={isBlocked || isCurrent}
                  key={label}
                  onClick={() => {
                    navigateFn(url);
                  }}
                  text={label}
                />
              </Tooltip>
            </S.BreadcrumbElement>
          </Fragment>
        );
      })}
    </S.BreadcrumbWrapper>
  );
};
